"use client";

import React from 'react';
import styles from './_gc-hce-display.module.scss';
import { GC_CALC_POPULATION } from '@/data/gc-calculator-data';

/**
 * @description GC OPTIMIZE™ Calculator — HCe computed display
 * Inline summary shown after GC dose entry.
 * Adult:     "Based on those equivalents, your patient's current dose is: [X] HCe mg/day"
 * Pediatric: "Based on those equivalents, your patient's current dose is: [X] HCe mg/m²/day"
 *
 * @param {number} hceTotal   — computed total from computeTotalHce()
 * @param {string} population — GC_CALC_POPULATION.ADULT | PEDIATRIC
 */
function GcHceDisplay({ hceTotal, population }) {
  const unit = population === GC_CALC_POPULATION.PEDIATRIC
    ? 'HCe mg/m\u00B2/day'
    : 'HCe mg/day';

  return (
    <div className={styles.gc_hce_display}>
      <p className={styles.lead_in}>
        <strong>Based on those equivalents, your patient&apos;s current dose is:</strong>
      </p>
      <p className={styles.value_bar}>
        <strong>{hceTotal ?? 'XX'} {unit}</strong>
      </p>
    </div>
  );
}

export default GcHceDisplay;
